import React from "react";
import styled from "styled-components";

const HeaderDiv = styled.div`
font-size: 15px;
color: #FFFFFF;
font-family: "Source Sans Pro",sans-serif;
background-color: #605f70;
margin-top: 15px;
margin-left: 15px;
margin-right: 15px;
border-bottom: 1px solid #e0e0e0;
padding-left: 15px;
padding-top: 12px;
height: 48px;
border-radius: 4px 4px 0 0;
font-weight: 600;
display: flex;
    justify-content: space-between;
`;

const HeaderTitle = styled.div`

`;

export default function TabHeader(props) {
  return (
    <HeaderDiv>
      <HeaderTitle>
        {props.entiteName ? props.entiteName : ""}
      </HeaderTitle>
    </HeaderDiv>
  );
}
